(function () {
  'use strict';

  var API_BASE = 'https://www.pricecharting.com/api/product';
  var CACHE_TTL = 24 * 60 * 60 * 1000;
  var RATE_MS = 1100;

  var config = {};
  var bountyData = null; // pre-baked static data (names, images)
  var cardsData = null;  // pre-baked card data
  var quoteItems = [];
  var productDataMap = {};
  var loadedCategories = {};
  var currentGroup = 'games';

  /* ── Init ───────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    var configEl = document.getElementById('bounty-config');
    if (!configEl) return;

    try { config = JSON.parse(configEl.textContent); }
    catch (e) { console.error('Bounty config error:', e); return; }

    if (!config.apiToken) {
      document.querySelectorAll('.bounty-loading').forEach(function (el) {
        el.textContent = 'API token not configured.';
      });
      return;
    }

    restoreQuote();
    initQuoteDrawer();
    initQuoteForm();
    initUnlistedForms();
    initStickyBar();
    initSearch();
    initTopTabs();

    // Load the pre-baked data, then init tabs
    loadBountyData();
  });

  /* ── Load Pre-baked Data ────────────────────────────── */
  function loadBountyData() {
    var script = document.getElementById('bounty-static-data');
    if (script) {
      try {
        bountyData = JSON.parse(script.textContent);
      } catch (e) {
        bountyData = null;
      }
    }

    if (!bountyData) {
      // Fallback: try to fetch the asset
      fetch(config.dataUrl || '/cdn/shop/t/1/assets/bounty-data.json')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          bountyData = data;
          initTabs();
          var firstTab = document.querySelector('.bounty-tab.active');
          if (firstTab) loadCategory(parseInt(firstTab.dataset.tabIndex));
        })
        .catch(function () {
          // No pre-baked data, fall back to API-only mode
          bountyData = null;
          initTabs();
          var firstTab = document.querySelector('.bounty-tab.active');
          if (firstTab) loadCategory(parseInt(firstTab.dataset.tabIndex));
        });
      return;
    }

    initTabs();
    var firstTab = document.querySelector('.bounty-tab.active');
    if (firstTab) loadCategory(parseInt(firstTab.dataset.tabIndex));
  }

  function loadCardsData(callback) {
    if (cardsData) { callback(); return; }
    if (!config.cardsDataUrl) { callback(); return; }
    fetch(config.cardsDataUrl)
      .then(function (res) { return res.json(); })
      .then(function (data) { cardsData = data; callback(); })
      .catch(function () { cardsData = null; callback(); });
  }

  /* ── Get pre-baked item by ID ───────────────────────── */
  function getStaticItem(categoryTitle, productId) {
    // Search games data
    if (bountyData) {
      var cat = bountyData.categories.find(function (c) { return c.title === categoryTitle; });
      if (cat) {
        var item = cat.items.find(function (item) { return item.id === String(productId); });
        if (item) return item;
      }
    }
    // Search cards data
    if (cardsData) {
      var cat2 = cardsData.categories.find(function (c) { return c.title === categoryTitle; });
      if (cat2) {
        var item2 = cat2.items.find(function (item) { return item.id === String(productId); });
        if (item2) return item2;
      }
    }
    return null;
  }

  /* ── Brand -> Console Mapping ─────────────────────── */
  var brandMap = {
    'nintendo': ['Nintendo 64','GameCube','SNES','NES','GameBoy','GameBoy Color','GameBoy Advance - GBA','Nintendo DS','Nintendo 3DS','Wii','Wii U','Switch'],
    'playstation': ['PlayStation 1','PlayStation 2'],
    'xbox': ['Original Xbox','Xbox 360']
  };

  var cardBrandMap = {
    'pokemon': []  // populated dynamically from config categories with group=cards
  };

  /* ── Top-Level Tabs (Games | Cards) ────────────────── */
  function initTopTabs() {
    document.querySelectorAll('.bounty-top-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var group = this.dataset.topTab;
        if (group === currentGroup) return;
        currentGroup = group;

        // Toggle active top tab
        document.querySelectorAll('.bounty-top-tab').forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');

        // Lock the panel height to prevent page jump during switch
        var panelEl = document.getElementById('bounty-panel');
        var currentHeight = panelEl.offsetHeight;
        panelEl.style.minHeight = currentHeight + 'px';

        // Toggle card mode class for styling
        var wrapper = document.querySelector('.price-list-inner');
        if (wrapper) {
          if (group === 'cards') wrapper.classList.add('bounty-mode-cards');
          else wrapper.classList.remove('bounty-mode-cards');
        }

        // Show/hide group navs
        document.getElementById('bounty-group-games').style.display = group === 'games' ? '' : 'none';
        document.getElementById('bounty-group-cards').style.display = group === 'cards' ? '' : 'none';

        // Clear any active search
        document.getElementById('bounty-search').value = '';
        var cardSearch = document.getElementById('bounty-card-search');
        if (cardSearch) cardSearch.value = '';
        clearSearch();

        // Hide all panels
        document.querySelectorAll('.bounty-panel-content').forEach(function (p) { p.classList.remove('active'); });

        if (group === 'cards') {
          loadCardsData(function () {
            // Build cardBrandMap dynamically from config
            buildCardBrandMap();

            // Hide brand tabs if only one brand
            var brandKeys = Object.keys(cardBrandMap);
            var brandRow = document.getElementById('bounty-card-brands');
            if (brandRow) brandRow.style.display = brandKeys.length <= 1 ? 'none' : '';

            var firstBrand = brandKeys[0] || 'pokemon';
            populateCardDropdown(firstBrand);

            // Hide dropdown if only one category
            var dropdown = document.getElementById('bounty-card-select');
            var selectWrap = document.getElementById('bounty-card-select-wrap');
            if (selectWrap && dropdown) selectWrap.style.display = dropdown.options.length <= 1 ? 'none' : '';

            if (dropdown && dropdown.options.length > 0) {
              dropdown.selectedIndex = 0;
              switchToConsole(parseInt(dropdown.value));
            }

            setTimeout(function () { panelEl.style.minHeight = ''; }, 100);
          });
        } else {
          populateDropdown('nintendo');
          var dropdown = document.getElementById('bounty-console-select');
          if (dropdown && dropdown.options.length > 0) {
            dropdown.selectedIndex = 0;
            switchToConsole(parseInt(dropdown.value));
          }
          setTimeout(function () { panelEl.style.minHeight = ''; }, 100);
        }
      });
    });
  }

  function buildCardBrandMap() {
    // For now, all card categories go under their brand.
    // We'll detect brand from the card brand tabs in the HTML
    // and match category titles. Initially all cards = pokemon.
    cardBrandMap = { 'pokemon': [] };
    config.categories.forEach(function (cat) {
      if (cat.group === 'cards') {
        // Default: put under pokemon. When more brands are added,
        // add a brand field to the block or parse from title.
        cardBrandMap['pokemon'].push(cat.title);
      }
    });
  }

  /* ── Tabs ───────────────────────────────────────────── */
  function initTabs() {
    var dropdown = document.getElementById('bounty-console-select');

    // Game brand tab clicks
    document.querySelectorAll('#bounty-group-games .bounty-brand-tab').forEach(function (brandTab) {
      brandTab.addEventListener('click', function () {
        var brand = this.dataset.brand;

        // Switch active brand tab
        document.querySelectorAll('#bounty-group-games .bounty-brand-tab').forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');

        // Populate dropdown with this brand's consoles
        populateDropdown(brand);

        // Auto-select the first console
        if (dropdown && dropdown.options.length > 0) {
          dropdown.selectedIndex = 0;
          switchToConsole(parseInt(dropdown.value));
        }
      });
    });

    // Game dropdown change
    if (dropdown) {
      dropdown.addEventListener('change', function () {
        switchToConsole(parseInt(this.value));
      });
    }

    // Card brand tab clicks
    document.querySelectorAll('#bounty-group-cards .bounty-brand-tab').forEach(function (brandTab) {
      brandTab.addEventListener('click', function () {
        var brand = this.dataset.brand;
        document.querySelectorAll('#bounty-group-cards .bounty-brand-tab').forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
        populateCardDropdown(brand);
        var cardDropdown = document.getElementById('bounty-card-select');
        if (cardDropdown && cardDropdown.options.length > 0) {
          cardDropdown.selectedIndex = 0;
          switchToConsole(parseInt(cardDropdown.value));
        }
      });
    });

    // Card dropdown change
    var cardDropdown = document.getElementById('bounty-card-select');
    if (cardDropdown) {
      cardDropdown.addEventListener('change', function () {
        switchToConsole(parseInt(this.value));
      });
    }

    // Init: populate Nintendo consoles
    populateDropdown('nintendo');
  }

  function populateDropdown(brand) {
    var dropdown = document.getElementById('bounty-console-select');
    if (!dropdown) return;
    var consoles = brandMap[brand] || [];

    dropdown.innerHTML = '';
    config.categories.forEach(function (cat) {
      if ((!cat.group || cat.group === 'games') && consoles.indexOf(cat.title) !== -1) {
        var opt = document.createElement('option');
        opt.value = cat.index;
        opt.textContent = cat.title;
        dropdown.appendChild(opt);
      }
    });
  }

  function populateCardDropdown(brand) {
    var dropdown = document.getElementById('bounty-card-select');
    if (!dropdown) return;
    var sets = cardBrandMap[brand] || [];

    dropdown.innerHTML = '';
    config.categories.forEach(function (cat) {
      if (cat.group === 'cards' && sets.indexOf(cat.title) !== -1) {
        var opt = document.createElement('option');
        opt.value = cat.index;
        opt.textContent = cat.title;
        dropdown.appendChild(opt);
      }
    });
  }

  function switchToConsole(index) {
    document.querySelectorAll('.bounty-panel-content').forEach(function (p) { p.classList.remove('active'); });
    var panel = document.querySelector('.bounty-panel-content[data-panel-index="' + index + '"]');
    if (panel) panel.classList.add('active');
    loadCategory(index);
  }

  /* ── Category Loading ───────────────────────────────── */
  function loadCategory(index) {
    if (loadedCategories[index]) return;
    loadedCategories[index] = true;

    var cat = config.categories.find(function (c) { return c.index === index; });
    if (!cat) return;

    var panel = document.querySelector('.bounty-panel-content[data-panel-index="' + index + '"]');
    if (!panel) return;
    var grid = panel.querySelector('.bounty-items-grid');

    var ids = cat.productIds
      .map(function (id) { return id.trim(); })
      .filter(function (id) { return id.length > 0; });

    if (ids.length === 0) {
      grid.innerHTML = '<p class="bounty-empty">No items configured for this category.</p>';
      return;
    }

    var tier = config.tiers[cat.tier] || config.tiers.mid;
    var cashPct = tier.cash;
    var creditPct = tier.credit;

    grid.innerHTML = '';

    // Render all rows INSTANTLY with pre-baked names + images
    var uncachedIds = [];
    ids.forEach(function (id) {
      var staticItem = getStaticItem(cat.title, id);
      var cached = getCache(id);

      if (cached) {
        // Have cached price data — render fully loaded row
        productDataMap[id] = cached;
        grid.appendChild(buildLoadedRow(id, cached, cashPct, creditPct, cat.title, staticItem));
      } else if (staticItem) {
        // Have pre-baked name + image, but need price
        grid.appendChild(buildPrebakedRow(id, staticItem, cashPct, creditPct, cat.title));
        uncachedIds.push(id);
      } else {
        // No pre-baked data, no cache — skeleton
        var el = document.createElement('div');
        el.className = 'bounty-row bounty-row--loading';
        el.dataset.productId = id;
        el.innerHTML =
          '<div class="bounty-row-name"><span class="skeleton-bar"></span></div>' +
          '<div class="bounty-row-prices"><span class="bounty-row-loading-dots"></span></div>' +
          '<label class="bounty-row-check"><input type="checkbox" class="bounty-checkbox" disabled /></label>';
        grid.appendChild(el);
        uncachedIds.push(id);
      }
    });

    // Fetch prices for uncached items (1/sec)
    var loadNext = function (i) {
      if (i >= uncachedIds.length) return;
      fetchProduct(uncachedIds[i]).then(function (data) {
        var row = grid.querySelector('.bounty-row[data-product-id="' + CSS.escape(uncachedIds[i]) + '"]');
        if (row) {
          var staticItem = getStaticItem(cat.title, uncachedIds[i]);
          var newRow = buildLoadedRow(uncachedIds[i], data, cashPct, creditPct, cat.title, staticItem);
          row.replaceWith(newRow);
        }
        loadNext(i + 1);
      }).catch(function () {
        var row = grid.querySelector('.bounty-row[data-product-id="' + CSS.escape(uncachedIds[i]) + '"]');
        if (row) {
          row.querySelector('.bounty-row-prices').innerHTML = '<span class="bounty-row-unavail">Price unavailable</span>';
          row.classList.remove('bounty-row--loading');
        }
        loadNext(i + 1);
      });
    };
    loadNext(0);
  }

  /* ── Build pre-baked row (name + image instant, price loading) ── */
  function buildPrebakedRow(productId, staticItem, cashPct, creditPct, categoryTitle) {
    var el = document.createElement('div');
    el.className = 'bounty-row bounty-row--loading';
    el.dataset.productId = productId;
    el.dataset.productName = staticItem.name.toLowerCase();
    el.dataset.consoleName = (staticItem.console || '').toLowerCase();

    el.innerHTML =
      '<div class="bounty-row-img"><img src="' + escapeHtml(staticItem.image) + '" alt="" loading="lazy" width="50" height="50" onerror="this.style.display=\'none\'" /></div>' +
      '<div class="bounty-row-name">' + escapeHtml(staticItem.name) + '</div>' +
      '<div class="bounty-row-prices"><span class="bounty-row-loading-dots">Loading price...</span></div>' +
      '<label class="bounty-row-check"><input type="checkbox" class="bounty-checkbox" disabled /></label>';

    return el;
  }

  /* ── Build fully loaded row ─────────────────────────── */
  function buildLoadedRow(productId, data, cashPct, creditPct, categoryTitle, staticItem) {
    // For cards, PriceCharting may use 'ungraded-price' instead of 'loose-price'
    var rawPrice = data['loose-price'] || data['ungraded-price'] || 0;
    var loosePrice = rawPrice / 100;
    var consoleName = data['console-name'] || (staticItem ? staticItem.console : '') || '';
    var productName = (staticItem ? staticItem.name : null) || data['product-name'] || productId;
    var imageUrl = staticItem ? staticItem.image : '';
    var cashOffer = Math.round(loosePrice * cashPct) / 100;
    var creditOffer = Math.round(loosePrice * creditPct) / 100;
    var isChecked = quoteItems.some(function (q) { return q.productId === productId; });

    var el = document.createElement('div');
    el.className = 'bounty-row';
    el.dataset.productId = productId;
    el.dataset.productName = productName.toLowerCase();
    el.dataset.consoleName = consoleName.toLowerCase();

    var imgHtml = imageUrl
      ? '<div class="bounty-row-img"><img src="' + escapeHtml(imageUrl) + '" alt="" loading="lazy" width="50" height="50" onerror="this.style.display=\'none\'" /></div>'
      : '';

    el.innerHTML =
      imgHtml +
      '<div class="bounty-row-name">' + escapeHtml(productName) + '</div>' +
      '<div class="bounty-row-prices">' +
        '<span class="bounty-row-cash"><span class="bounty-row-label">Cash:</span> ' + formatMoney(cashOffer) + '</span>' +
        '<span class="bounty-row-credit"><span class="bounty-row-label">Store Credit:</span> ' + formatMoney(creditOffer) + '</span>' +
      '</div>' +
      '<label class="bounty-row-check">' +
        '<input type="checkbox" class="bounty-checkbox"' + (isChecked ? ' checked' : '') + ' />' +
      '</label>';

    el._bountyData = {
      productId: productId, name: productName, consoleName: consoleName,
      category: categoryTitle, condition: 'loose',
      marketPrice: loosePrice, cashOffer: cashOffer, creditOffer: creditOffer
    };

    el.querySelector('.bounty-checkbox').addEventListener('change', function () {
      if (this.checked) { addToQuote(el._bountyData); }
      else { removeFromQuoteById(productId); }
    });

    return el;
  }

  /* ── API Fetch with Rate Limiting ───────────────────── */
  var lastCallTime = 0;

  function fetchProduct(productId) {
    var cached = getCache(productId);
    if (cached) {
      productDataMap[productId] = cached;
      return Promise.resolve(cached);
    }

    var now = Date.now();
    var wait = Math.max(0, RATE_MS - (now - lastCallTime));

    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        lastCallTime = Date.now();
        var param = productId.length >= 10 ? 'upc' : 'id';
        var url = API_BASE + '?t=' + encodeURIComponent(config.apiToken) + '&' + param + '=' + encodeURIComponent(productId);

        fetch(url)
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status === 'error') { reject(data['error-message']); return; }
            productDataMap[productId] = data;
            setCache(productId, data);
            resolve(data);
          })
          .catch(reject);
      }, wait);
    });
  }

  /* ── Cache ──────────────────────────────────────────── */
  function getCache(id) {
    try {
      var raw = localStorage.getItem('pc_' + id);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (Date.now() - entry.ts > CACHE_TTL) { localStorage.removeItem('pc_' + id); return null; }
      return entry.data;
    } catch (e) { return null; }
  }

  function setCache(id, data) {
    try { localStorage.setItem('pc_' + id, JSON.stringify({ data: data, ts: Date.now() })); }
    catch (e) {}
  }

  /* ── Unlisted Item Form ─────────────────────────────── */
  function initUnlistedForms() {
    var addBtn = document.getElementById('drawer-unlisted-add');
    var input = document.getElementById('drawer-unlisted-input');
    if (!addBtn || !input) return;

    addBtn.addEventListener('click', function () {
      var value = input.value.trim();
      if (!value) return;
      addToQuote({
        productId: 'unlisted_' + Date.now(), name: value, consoleName: '', category: 'Unlisted',
        condition: 'unknown', marketPrice: 0, cashOffer: 0, creditOffer: 0, isUnlisted: true
      });
      input.value = '';
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); addBtn.click(); }
    });
  }

  /* ── Quote Builder ──────────────────────────────────── */
  function addToQuote(itemData) {
    var existing = quoteItems.find(function (q) { return q.productId === itemData.productId; });
    if (existing) return;
    quoteItems.push({
      productId: itemData.productId, name: itemData.name, consoleName: itemData.consoleName,
      category: itemData.category, condition: itemData.condition, marketPrice: itemData.marketPrice,
      cashOffer: itemData.cashOffer, creditOffer: itemData.creditOffer, isUnlisted: itemData.isUnlisted || false
    });
    saveQuote(); renderQuote(); updateStickyBar();
  }

  function removeFromQuoteById(productId) {
    quoteItems = quoteItems.filter(function (q) { return q.productId !== productId; });
    var cb = document.querySelector('.bounty-row[data-product-id="' + productId + '"] .bounty-checkbox');
    if (cb) cb.checked = false;
    saveQuote(); renderQuote(); updateStickyBar();
  }

  function removeFromQuoteByIndex(index) {
    var item = quoteItems[index];
    if (!item) return;
    var pid = item.productId;
    quoteItems.splice(index, 1);
    var cb = document.querySelector('.bounty-row[data-product-id="' + pid + '"] .bounty-checkbox');
    if (cb) cb.checked = false;
    saveQuote(); renderQuote(); updateStickyBar();
  }

  function renderQuote() {
    var container = document.getElementById('quote-items');
    var totalsEl = document.getElementById('quote-totals');
    if (quoteItems.length === 0) {
      container.innerHTML = '<p class="quote-empty">Check items from the bounty list to add them to your quote.</p>';
      totalsEl.innerHTML = '';
      return;
    }
    var totalCash = 0, totalCredit = 0, html = '';
    quoteItems.forEach(function (item, i) {
      totalCash += item.cashOffer; totalCredit += item.creditOffer;
      var priceHtml = item.isUnlisted ? '<span class="quote-item-prices">Unlisted — priced in store</span>'
        : '<span class="quote-item-prices">Cash ' + formatMoney(item.cashOffer) + ' / Credit ' + formatMoney(item.creditOffer) + '</span>';
      html += '<div class="quote-item"><div class="quote-item-info"><strong>' + escapeHtml(item.name) + '</strong>' +
        '<span class="quote-item-meta">' + escapeHtml(item.category) + '</span>' + priceHtml +
        '</div><button type="button" class="quote-item-remove" data-index="' + i + '">&times;</button></div>';
    });
    container.innerHTML = html;
    totalsEl.innerHTML = '<div class="quote-total-row"><strong>Total Cash Offer:</strong> ' + formatMoney(totalCash) + '</div>' +
      '<div class="quote-total-row"><strong>Total Store Credit:</strong> ' + formatMoney(totalCredit) + '</div>' +
      (quoteItems.some(function (q) { return q.isUnlisted; }) ? '<div class="quote-total-note">* Unlisted items priced in store.</div>' : '');
    container.querySelectorAll('.quote-item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () { removeFromQuoteByIndex(parseInt(btn.dataset.index)); });
    });
  }

  /* ── Sticky Bar ─────────────────────────────────────── */
  function initStickyBar() {
    document.getElementById('quote-prepare-btn').addEventListener('click', openDrawer);
    var collapseBtn = document.getElementById('quote-sticky-collapse');
    collapseBtn.addEventListener('click', function () {
      var bar = document.getElementById('quote-sticky-bar');
      bar.classList.toggle('collapsed');
      collapseBtn.textContent = bar.classList.contains('collapsed') ? '+' : '-';
    });
    updateStickyBar();
  }

  function updateStickyBar() {
    var bar = document.getElementById('quote-sticky-bar');
    document.getElementById('quote-count-bar').textContent = quoteItems.length;
    bar.style.display = quoteItems.length > 0 ? 'block' : 'none';
  }

  /* ── Quote Drawer ───────────────────────────────────── */
  function initQuoteDrawer() {
    document.getElementById('quote-drawer-close').addEventListener('click', closeDrawer);
    document.getElementById('quote-overlay').addEventListener('click', closeDrawer);
  }
  function openDrawer() {
    document.getElementById('quote-drawer').classList.add('open');
    document.getElementById('quote-overlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    document.getElementById('quote-drawer').classList.remove('open');
    document.getElementById('quote-overlay').classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ── Quote Persistence ──────────────────────────────── */
  function saveQuote() { try { sessionStorage.setItem('bounty_quote', JSON.stringify(quoteItems)); } catch (e) {} }
  function restoreQuote() {
    try {
      var saved = sessionStorage.getItem('bounty_quote');
      if (saved) { quoteItems = JSON.parse(saved); if (quoteItems.length > 0) { renderQuote(); updateStickyBar(); } }
    } catch (e) { quoteItems = []; }
  }

  /* ── Quote Form Submission ──────────────────────────── */
  function initQuoteForm() {
    var form = document.getElementById('BountyQuoteForm');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (quoteItems.length === 0) { alert('Please add items to your quote first.'); return; }
      var name = document.getElementById('quote-name').value.trim();
      var email = document.getElementById('quote-email').value.trim();
      var phone = document.getElementById('quote-phone').value.trim();
      var contactMethod = (document.getElementById('quote-contact-method') || {}).value || '';
      var location = document.getElementById('quote-location').value;
      if (!name || !email) { alert('Please enter your name and email.'); return; }
      if (!contactMethod) { alert('Please select your preferred contact method.'); return; }
      if (!location) { alert('Please select a store location.'); return; }
      var isMailIn = location === 'Mail-In';

      var submitBtn = document.getElementById('submit-quote');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Submitting...'; }

      // Fire Discord webhook (in-store only)
      if (!isMailIn) { postToDiscord(location, name, email, phone); }

      // Build payload for Apps Script
      var items = quoteItems.map(function (item) {
        return {
          name: item.name,
          category: item.category || '',
          marketPrice: item.marketPrice,
          cashOffer: item.cashOffer,
          creditOffer: item.creditOffer,
          isUnlisted: !!item.isUnlisted
        };
      });
      var payload = {
        type: 'bounty-quote',
        website: (document.querySelector('#BountyQuoteForm [name="website"]') || {}).value || '',
        formLoadedAt: (document.querySelector('#BountyQuoteForm [name="formLoadedAt"]') || {}).value || '',
        name: name, email: email, phone: phone,
        contact_method: contactMethod,
        location: location, isMailIn: isMailIn,
        items: items
      };

      var scriptUrl = config.formsScriptUrl;
      if (!scriptUrl || scriptUrl.indexOf('PASTE_') === 0) {
        console.error('formsScriptUrl not configured');
        alert('Form system not yet configured. Please contact support.');
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Submit Trade Quote'; }
        return;
      }

      // Calculate total cash offer for the Meta Lead event (helps optimize for higher-value leads)
      var totalCashOffer = items.reduce(function (sum, it) {
        return sum + (Number(it.cashOffer) || 0);
      }, 0);

      // Fire Meta Pixel Lead event (Facebook ad conversion tracking)
      if (typeof window.fbq === 'function') {
        try {
          window.fbq('track', 'Lead', {
            content_name: 'Bounty Trade Quote',
            content_category: isMailIn ? 'Mail-In' : 'In-Store',
            num_items: items.length,
            value: Math.round(totalCashOffer * 100) / 100,
            currency: 'USD'
          });
        } catch (e) { /* swallow tracking errors */ }
      }

      fetch(scriptUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      }).then(function () {
        showBountySuccess(form);
      }).catch(function (err) {
        console.error('Form submit error:', err);
        showBountySuccess(form);
      });

      quoteItems = []; saveQuote();
    });
  }

  function showBountySuccess(form) {
    form.style.display = 'none';
    var successEl = document.getElementById('bounty-quote-success');
    if (successEl) successEl.style.display = 'block';
  }

  /* ── Discord Webhook ────────────────────────────────── */
  function postToDiscord(location, name, email, phone) {
    var webhooks = config.discordWebhooks || {};
    var webhookUrl = webhooks[location];
    if (!webhookUrl) return;
    var today = new Date();
    var expiryDate = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000);
    var totalCash = 0, totalCredit = 0, itemLines = [];
    quoteItems.forEach(function (item, i) {
      totalCash += item.cashOffer; totalCredit += item.creditOffer;
      if (item.isUnlisted) { itemLines.push('**' + (i + 1) + '.** ' + item.name + ' _(Unlisted)_'); }
      else { itemLines.push('**' + (i + 1) + '.** ' + item.name + ' (' + item.category + ') — Cash: ' + formatMoney(item.cashOffer) + ' | Store Credit: ' + formatMoney(item.creditOffer)); }
    });
    fetch(webhookUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ embeds: [{ title: 'New Bounty Trade Quote Request', color: 16738563,
        fields: [
          { name: 'Customer', value: name, inline: true }, { name: 'Email', value: email, inline: true },
          { name: 'Phone', value: phone || 'N/A', inline: true }, { name: 'Location', value: location, inline: true },
          { name: 'Quote Date', value: today.toLocaleDateString(), inline: true }, { name: 'Valid Until', value: expiryDate.toLocaleDateString(), inline: true },
          { name: 'Items (' + quoteItems.length + ')', value: itemLines.join('\n') || 'None' },
          { name: 'Total Cash', value: formatMoney(totalCash), inline: true }, { name: 'Total Credit', value: formatMoney(totalCredit), inline: true }
        ], footer: { text: 'Play & Talk Trade Quote System' }, timestamp: today.toISOString()
      }]})
    }).catch(function (err) { console.error('Discord error:', err); });
  }

  function buildQuoteBody(name, email, phone, location, isMailIn) {
    var totalCash = 0, totalCredit = 0, today = new Date();
    var expiryDate = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000);
    var heading = isMailIn ? 'MAIL-IN TRADE QUOTE REQUEST' : 'TRADE QUOTE REQUEST';
    var lines = [heading, '===================='];
    if (isMailIn) lines.push('*** MAIL-IN REQUEST — Customer wants to ship items ***', '');
    lines.push('Customer: ' + name, 'Email: ' + email);
    if (phone) lines.push('Phone: ' + phone);
    if (location) lines.push('Method: ' + (isMailIn ? 'Mail-In' : 'In-Store: ' + location));
    lines.push('Quote Date: ' + today.toLocaleDateString(), 'Valid Until: ' + expiryDate.toLocaleDateString(), '', 'ITEMS:');
    quoteItems.forEach(function (item, i) {
      totalCash += item.cashOffer; totalCredit += item.creditOffer;
      if (item.isUnlisted) { lines.push((i + 1) + '. [UNLISTED] ' + item.name, '   Priced in store.'); }
      else { lines.push((i + 1) + '. ' + item.name + ' (' + item.category + ')', '   Market: ' + formatMoney(item.marketPrice), '   Cash: ' + formatMoney(item.cashOffer) + ' | Credit: ' + formatMoney(item.creditOffer)); }
      lines.push('');
    });
    lines.push('TOTALS:', 'Cash: ' + formatMoney(totalCash), 'Credit: ' + formatMoney(totalCredit), '', '* Valid 7 days from ' + today.toLocaleDateString());
    return lines.join('\n');
  }

  /* ── Search (scoped to active group) ───────────────── */
  function initSearch() {
    setupSearchInput('bounty-search');
    setupSearchInput('bounty-card-search');
  }

  function setupSearchInput(inputId) {
    var input = document.getElementById(inputId);
    if (!input) return;
    var timeout;
    input.addEventListener('input', function () {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        var q = input.value.trim().toLowerCase();
        if (!q) { clearSearch(); return; }
        runSearch(q);
      }, 200);
    });
  }

  function runSearch(query) {
    var data = currentGroup === 'cards' ? cardsData : bountyData;
    if (!data) return;

    var resultsPanel = document.getElementById('bounty-search-results');
    var grid = document.getElementById('bounty-search-grid');
    var countEl = document.getElementById('bounty-search-count');
    var clearBtn = document.getElementById('bounty-search-clear');
    var gamesNav = document.getElementById('bounty-group-games');
    var cardsNav = document.getElementById('bounty-group-cards');
    var panel = document.getElementById('bounty-panel');

    // Search across categories in the active group's pre-baked data
    var matches = [];
    data.categories.forEach(function (cat) {
      var configCat = config.categories.find(function (c) { return c.title === cat.title && (c.group || 'games') === currentGroup; });
      var tier = configCat ? (config.tiers[configCat.tier] || config.tiers.mid) : config.tiers.mid;

      cat.items.forEach(function (item) {
        if (item.name.toLowerCase().indexOf(query) !== -1 ||
            item.console.toLowerCase().indexOf(query) !== -1) {
          matches.push({ item: item, category: cat.title, cashPct: tier.cash, creditPct: tier.credit });
        }
      });
    });

    // Show search results, hide nav + panels
    if (currentGroup === 'games' && gamesNav) gamesNav.style.display = 'none';
    if (currentGroup === 'cards' && cardsNav) cardsNav.style.display = 'none';
    panel.style.display = 'none';
    resultsPanel.style.display = 'block';
    countEl.textContent = matches.length + ' result' + (matches.length !== 1 ? 's' : '') + ' for "' + query + '"';

    // Wire up clear button
    if (clearBtn) {
      clearBtn.onclick = function () {
        document.getElementById('bounty-search').value = '';
        document.getElementById('bounty-card-search').value = '';
        clearSearch();
      };
    }

    grid.innerHTML = '';
    if (matches.length === 0) {
      grid.innerHTML = '<p class="bounty-empty">No items found.</p>';
      return;
    }

    matches.forEach(function (m) {
      var cached = getCache(m.item.id);
      if (cached) {
        grid.appendChild(buildLoadedRow(m.item.id, cached, m.cashPct, m.creditPct, m.category, m.item));
      } else {
        grid.appendChild(buildPrebakedRow(m.item.id, m.item, m.cashPct, m.creditPct, m.category));
      }
    });

    // Fetch prices for uncached search results
    var uncached = matches.filter(function (m) { return !getCache(m.item.id); });
    var loadNext = function (i) {
      if (i >= uncached.length) return;
      var m = uncached[i];
      fetchProduct(m.item.id).then(function (data) {
        var row = grid.querySelector('.bounty-row[data-product-id="' + CSS.escape(m.item.id) + '"]');
        if (row) row.replaceWith(buildLoadedRow(m.item.id, data, m.cashPct, m.creditPct, m.category, m.item));
        loadNext(i + 1);
      }).catch(function () {
        var row = grid.querySelector('.bounty-row[data-product-id="' + CSS.escape(m.item.id) + '"]');
        if (row) { row.querySelector('.bounty-row-prices').innerHTML = '<span class="bounty-row-unavail">Price unavailable</span>'; row.classList.remove('bounty-row--loading'); }
        loadNext(i + 1);
      });
    };
    loadNext(0);
  }

  function clearSearch() {
    var resultsPanel = document.getElementById('bounty-search-results');
    var gamesNav = document.getElementById('bounty-group-games');
    var cardsNav = document.getElementById('bounty-group-cards');
    var panel = document.getElementById('bounty-panel');

    resultsPanel.style.display = 'none';
    if (currentGroup === 'games' && gamesNav) gamesNav.style.display = '';
    if (currentGroup === 'cards' && cardsNav) cardsNav.style.display = '';
    panel.style.display = '';
  }

  /* ── Helpers ────────────────────────────────────────── */
  function formatMoney(a) { return '$' + Math.round(a); }
  function escapeHtml(s) { var d = document.createElement('div'); d.appendChild(document.createTextNode(s)); return d.innerHTML; }
})();
